
export const popularproduct = [


  {
    "id": 1,
    "name": "Aquarium Kit",
    "price": 1500,
    "image": "src/assets/optimum.png"
  },
  {
    "id": 2,
    "name": "Dog Food",
    "price": 500,
    "image": "/images/dog-food.jpg"
  },
  {
    "id": 3,
    "name": "Cat Toy",
    "price": 250,
    "image": "/images/cat-toy.jpg"
  }
]



export const navList = [
  {
    id: 1,
    name: 'Home',
    navi: '/'
  },
  {
    id: 2,
    name: 'Aqua',
    navi: '/aqua',
    mincat: 'aqua'
  },
  {
    id: 3,
    name: 'Dogs',
    navi: '/dogs',
    mincat: 'dog'
  },
  {
    id: 4,
    name: 'Cats',
    navi: '/cats',
    mincat: 'cat'
  },
  {
    id: 5,
    name: 'Birds',
    navi: '/birds',
    mincat: 'bird',
  },
]